import Button from 'components/base/Button';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';

const ResetPasswordForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { handleConfirmResetPassword } = useAuth();
  const email = (location.state as { email?: string } | null)?.email ?? '';

  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage('');
    if (!email) {
      setErrorMessage('Session expired. Please request a new reset link from the forgot password page.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setErrorMessage('Passwords do not match.');
      return;
    }
    if (!code.trim()) {
      setErrorMessage('Please enter the code from your email.');
      return;
    }
    setIsLoading(true);
    const result = await handleConfirmResetPassword(email, code.trim(), newPassword);
    setIsLoading(false);
    if (result.success) {
      navigate('../sign-in', { state: { message: result.message } });
    } else {
      setErrorMessage(result.message);
    }
  };

  if (!email) {
    return (
      <div className="text-center mb-6">
        <h4 className="text-1000">Reset password</h4>
        <p className="text-700 mb-4">
          This page is only available after requesting a password reset. Enter your email on the forgot password page to receive a code.
        </p>
        <Link to="../forgot-password" className="fw-bold">
          Go to Forgot Password
        </Link>
      </div>
    );
  }

  return (
    <div className="text-center mb-6">
      <h4 className="text-1000">Reset new password</h4>
      <p className="text-700">Enter the code from your email and choose a new password</p>
      <Form className="mt-5 text-start" onSubmit={handleSubmit}>
        <Form.Group className="mb-2">
          <Form.Control
            className="mb-2"
            id="code"
            type="text"
            placeholder="Reset code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            disabled={isLoading}
            autoComplete="one-time-code"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Control
            className="mb-2"
            id="password"
            type="password"
            placeholder="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            disabled={isLoading}
            autoComplete="new-password"
          />
        </Form.Group>
        <Form.Group className="mb-4">
          <Form.Control
            className="mb-2"
            id="confirmPassword"
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            disabled={isLoading}
            autoComplete="new-password"
          />
        </Form.Group>
        {errorMessage && (
          <div className="text-danger small mb-3">{errorMessage}</div>
        )}
        <Button
          type="submit"
          variant="primary"
          className="w-100"
          disabled={isLoading}
        >
          {isLoading ? 'Setting password…' : 'Set Password'}
        </Button>
      </Form>
    </div>
  );
};

export default ResetPasswordForm;
